const THREE_WORDS = /\b[\w']+(?:[^\w\n]+[\w']+){0,2}\b/g

function toHtmlClass(text) {
  return text
    .match(THREE_WORDS)[0]
    .toLowerCase()
    .replace(/\W/g, '-')
    .replace(/--/g, '-')
}

export default toHtmlClass
